<template>
  <div class="coupon-page">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header title="友邻少年" back-type="back-app" />
    <!-- 倒计时 -->
    <div v-if="canUse && showCount" class="countDown">
      <div>优惠倒计时</div>
      <CountDown :time="time">
        <template #default="timeData">
          <div class="flexbox countDown_box">
            <div v-show="timeData.days > 0">
              <span v-for="(item, index) in zero(timeData.days)" :key="index">{{ item }}</span>
              天
            </div>
            <div>
              <span v-for="(item, index) in zero(timeData.hours)" :key="index">{{ item }}</span>
              时
            </div>
            <div>
              <span v-for="(item, index) in zero(timeData.minutes)" :key="index">{{ item }}</span>
              分
            </div>
            <div>
              <span v-for="(item, index) in zero(timeData.seconds)" :key="index">{{ item }}</span>
              秒
            </div>
          </div>
        </template>
      </CountDown>
    </div>
    <!-- 优惠券列表 -->
    <div class="coupon_shadow-item" v-for="(item, index) in resetCouponList" :key="index">
      <div class="coupon-item" :class="{ invalid: item.invalid }">
        <!-- 优惠券内容 -->
        <div class="item-text">
          <div class="is-title">{{ item.discountName }}</div>
          <div class="is-desc">
            <!-- {{ `限${item.effectiveStartTime}至${item.effectiveEndTime}使用` }} -->
            {{ `仅限${item.effectiveEndTime}前使用` }}
          </div>
          <div class="is-desc" v-if="item.sourceType && item.sourceType == 'friend_gift'">
            用户{{ item.sourceId }}赠送
          </div>
          <div class="is-desc" v-if="item.sourceType && item.sourceType == 'order'">订单购买</div>
          <div class="is-desc" v-if="item.sourceType && item.sourceType == 'gift'">友邻赠送</div>
          <div class="is-desc" v-if="item.discountDesc == '全场通用'">
            {{ item.discountDesc }}
          </div>
          <div v-else>
            <div class="is-desc is-desc2" @click.stop="openRules(item)" v-if="showUseRule(item)">
              使用规则
              <img src="../../images/icon/icon_bom.png" alt="" />
            </div>
            <div class="is-desc is-desc2" @click.stop="closeRules(item)" v-if="!showUseRule(item)">
              使用规则
              <img src="../../images/icon/icon_up.png" alt="" />
            </div>
            <div class="" v-if="!showUseRule(item)">
              {{ item.useRule }}
            </div>
          </div>
        </div>
        <div class="border"></div>
        <div class="left"></div>
        <div class="right"></div>
        <!-- 优惠券折扣 -->
        <div class="item-price">
          <div class="is-title">
            <span v-if="item.type === 1">
              <span class="discount-text">{{ item.discountText }}</span>
              折
            </span>
            <span v-else>
              <span class="money">¥</span>
              <span class="discount-text">{{ item.discountText }}</span>
            </span>
          </div>
          <div class="is-range">{{ item.discountRange }}</div>
        </div>
      </div>
    </div>
    <div class="flexbox cover_box" v-if="resetCouponList.length > 0">
      <div class="flexbox sure_box" :class="{ opacity_box: !canUse }" @click="sureClick">
        {{ canUse ? '立即领取' : message }}
      </div>
      <!-- <div class="sure_tip">优惠券截止领取时间:{{ couponInfo.endTime }}</div> -->
    </div>
    <!-- 暂时弃用 -->
    <div v-if="resetCouponList.length === 0 && !loading">
      <div class="goods-empty-image"></div>
      <div class="goods-empty-label">
        <span class="label">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { CountDown } from 'vant'
import { mapGetters } from 'vuex'
import { MessageBox } from 'mint-ui'
import { debounce } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'
import { appUser } from '@/utils'

import Body from '@/mixins/body'

export default {
  components: { CountDown },
  mixins: [Body],
  data() {
    return {
      openRule: []
    }
  },
  computed: {
    ...mapGetters('payment/coupons', ['couponList', 'couponInfo', 'title', 'message', 'loading']),
    ...mapGetters('args', ['shareCode']),
    time() {
      const now = new Date().getTime()
      const str = this.couponInfo.endTime.replace(/-/g, '/')
      const end = new Date(str).getTime()
      return end - now
    },
    resetCouponList() {
      return (this.couponList || []).map(item => {
        const {
          name,
          type,
          couponDiscount,
          maxAmount,
          albumList = [],
          content,
          limitAmount,
          effectiveStartTime,
          effectiveEndTime
        } = item
        const discountText = type === 1 ? content : content // 如果是折扣 50 转换为 5
        const discountDesc =
          (albumList.length ? `仅限${albumList.map(name => `《${name}》`).join('、')}可用` : '全场通用') +
          (maxAmount ? `，最多优惠${maxAmount}元` : '')
        return {
          type,
          id: item.id,
          couponDiscount, // 已计算好的优惠金额
          discountText,
          discountRange: limitAmount ? `${limitAmount}` : '无使用门槛',
          discountName: name,
          useRule: item.useRule,
          sourceType: item.sourceType,
          sourceId: item.sourceId,
          effectiveEndTime: this.parseDate(effectiveEndTime),
          effectiveStartTime: this.parseDate(effectiveStartTime),
          discountDesc, // 西南联大可用，最多优惠100元
          invalid: item.status === 0 // 失效状态不查下
        }
      })
    },
    showUseRule() {
      return function (item) {
        if (this.openRule.indexOf(item.id) == -1) {
          return true
        }
        return false
      }
    },
    canUse() {
      if (this.couponInfo.isReceive) {
        return true
      }
      return false
    },
    showCount() {
      return this.couponInfo.isShowEndTime
    }
  },
  created() {
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.init()
  },
  activated() {
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.init()
  },
  methods: {
    init: debounce(
      function () {
        this.$store
          .dispatch('payment/coupons/getList', {
            shareCode: this.shareCode
          })
          .then(res => {
            this.haveCouponNext(res)
          })
      },
      2000,
      { leading: true }
    ),
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      setTimeout(() => {
        this.init()
      })
    },
    // 检查用户
    hasUser() {
      const action = 'couponList'
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    parseDate(str) {
      if (str) {
        str = str.replace(/(-)/g, '/')
        // console.log(str, new Date(str), this.$moment(str).format('YYYY-MM-DD hh:mm:ss'));
        return new Date(str).toFormattedString('yyyy年MM月dd日 hh:mm')
      }
    },
    zero(num) {
      return (num <= 9 ? `0${num}` : num).toString()
    },
    sureClick() {
      if (!this.couponInfo.isReceive) {
        return this.$toast(this.message)
      }
      this.$store
        .dispatch('payment/coupons/obtainCouponByLink', {
          shareCode: this.shareCode
        })
        .then(() => {
          this.$router.push('coupon_success')
        })
        .catch(err => {
          console.log('err---', err)
          this.haveCouponNext(err.data || {})
        })
    },
    haveCouponNext(obj) {
      // const dateStr = this.parseDate(obj.goodsSaleTime)
      if (obj.shareUrl) {
        // 已领优惠券且二次进入的情况
        const { isGoodsSale, shareUrl } = obj
        return MessageBox({
          title: '提醒',
          message: isGoodsSale
            ? '该优惠券您已拥有,可直接购买商品'
            : // : `该优惠券您已拥有,商品开始售卖时间为:${dateStr},请耐心等待~`,
              `该优惠券您已拥有,如有问题请联系班主任.`,
          confirmButtonText: isGoodsSale ? '去购买' : '确定',
          showCancelButton: isGoodsSale
        }).then(res => {
          if (res === 'confirm' && isGoodsSale) {
            return location.replace(shareUrl)
          }
        })
      }
    },
    openRules(item) {
      var index = this.openRule.indexOf(item.id)
      if (index == -1) {
        this.openRule.push(item.id)
      }
      console.log('this.openrule', this.openRule)
    },
    closeRules(item) {
      var index = this.openRule.indexOf(item.id)
      if (index != -1) {
        this.openRule.splice(index, 1)
      }
      console.log('this.openrule', this.openRule)
    }
  }
}
</script>

<style lang="less" scoped>
.countDown {
  font-size: 0.32rem;
  font-weight: 500;
  text-align: center;
  color: #000000;
  padding: 0.4rem 0 0;
  .countDown_box {
    justify-content: center;
    padding-top: 0.26rem;
    font-size: 0.28rem;
    font-weight: 500;
    div {
      margin: 0 0.05rem;
    }
    span {
      display: inline-block;
      color: #fff;
      width: 0.4rem;
      height: 0.4rem;
      text-align: center;
      line-height: 0.4rem;
      background: #00b25a;
      border-radius: 0.04rem;
      margin-right: 3px;
      &:last-child {
        margin-right: 6px;
      }
    }
  }
}

.goods-empty-image {
  background: url('../../../common/images/goods/goods-empty.png') no-repeat;
  background-size: 100% 100%;
  width: 200px;
  height: 200px;
  margin: 50px auto 0px auto;
}
.goods-empty-label {
  color: #666666;
  font-size: 16px;
  margin-bottom: 10px;
  text-align: center;
}
.coupon-page {
  padding-bottom: 3.1rem;
  background: #f1f2f3;
  height: 100%;
  overflow: auto;
  // 付款按钮
  .form-bottom-button.form-bottom-label {
    background-color: #f7f9fb;
    border-top: 1px solid #eeeeee;
    font-size: 0.28rem;
    // 优惠券使用
    .coupon-select {
      color: #666666;
      text-align: left;
      .price {
        color: #e65c53;
      }
    }
  }
  // 优惠券项
  .coupon_shadow-item {
    // background: url("../../../images/payment/coupon_shadow.png") no-repeat;
    background-size: 100% 100%;
    margin: 0.32rem 0.48rem 0.48rem;
  }
  .coupon-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.46rem 0.3rem 0.46rem 0.46rem;
    // background: url("../../../images/payment/coupon_board.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    color: #00b25a;
    width: 6.54rem;
    min-height: 2.54rem;
    background: #fff;
    border-radius: 0.16rem;
    .coupon_choose {
      background: url('../../images/payment/coupon_choose.png') no-repeat;
      background-size: 100% 100%;
      width: 0.64rem;
      height: 0.64rem;
      position: absolute;
      right: 0px;
      top: 0px;
      .selected {
        background: url('../../images/payment/coupon_choose_select.png') no-repeat;
        background-size: 100% 100%;
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 50%;
        position: absolute;
        right: 0.15rem;
        top: 0.16rem;
      }
    }
    // 选择
    .item-value {
      text-align: right;
      .iconcircle-selected {
        color: #00b25a;
      }
    }
    &.invalid {
      opacity: 0.4;
    }
    // 选中效果
    &.activate {
      color: #00b25a;
      .iconcircle-selected {
        color: #00b25a;
      }
    }
    // 优惠券折扣
    .item-price {
      width: 2rem;
      font-size: 0.24rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: start;
      // padding-left: .5rem;
      margin: 0 auto;
      .money {
        margin-left: 0.08rem;
      }
      .discount-text {
        font-size: 0.56rem;
        margin-right: 0.08rem;
      }
      .is-title {
        font-weight: bold;
        margin-bottom: 0.2rem;
      }
      .is-range {
        font-size: 0.24rem;
        line-height: 0.3rem;
      }
    }
    .border {
      height: 100%;
      position: absolute;
      top: 0;
      right: 2.39rem;
      border-right: 1px dashed #eeeeee;
    }
    .left {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      position: absolute;
      left: -0.2rem;
      top: 0;
      bottom: 0;
      margin: auto;
      background: #f1f2f3;
    }
    .right {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      position: absolute;
      right: -0.2rem;
      top: 0;
      bottom: 0;
      margin: auto;
      background: #f1f2f3;
    }
    // 优惠券名字
    .item-text {
      flex: 1;
      // border-left: solid 1px #e7e7e6;
      // padding-left: .5rem;
      text-align: left;
      font-size: 0.2rem;
      line-height: 0.34rem;
      color: #999999;
      padding-right: 0.28rem;
      .is-title {
        color: #000000;
        font-weight: bold;
        font-size: 0.32rem;
        line-height: 0.45rem;
        margin-bottom: 0.16rem;
      }
      .is-desc {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 0.38rem;
      }
      .is-desc2 {
        display: flex;
        align-items: center;
        img {
          width: 0.16rem;
          height: 0.1rem;
          margin-left: 0.08rem;
          display: block;
        }
      }
    }
  }
}
.cover_box {
  position: fixed;
  background: #f1f2f3;
  z-index: 100;
  width: 100%;
  height: 3rem;
  padding-top: 0.2rem;
  bottom: 0;
  left: 0;
  align-items: center;
  flex-direction: column;
}
.sure_box {
  font-size: 0.32rem;
  justify-content: center;
  color: #fff;
  width: 6.54rem;
  height: 0.88rem;
  background: #00b25a;
  border-radius: 0.08rem;
  margin: 0 auto;
}
.opacity_box {
  opacity: 0.6;
}
.sure_tip {
  margin-top: 0.3rem;
  font-size: 0.24rem;
  color: #666666;
}
</style>
